// import { useState } from 'react';
import { Notification } from '../Notification';

export const NotificationContainer = () => {
  // const [exibe, setExibe] = useState(false);

  // setTimeout(() => setExibe(true), 3000);

  return (
    <div>
      <div className="toast-container position-fixed bottom-0 end-1 p-3">
        <Notification text="Chegou um novo Canhoto do token #03" time="5 min" delay={3000} />
        <Notification text="Chegou um novo Canhoto do token #02" time="2 min" delay={2000} />
        <Notification text="Chegou um novo Canhoto do token #01" time="1 min" delay={500} />
        <div></div>
      </div>
    </div>
  );
};
